angular.module('gym.availability').factory('Availability', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('trainer_availabilities');
}]);
